export default __webpack_public_path__ + "static/media/img10.ea661b2e.PNG";